export type LegalDocId = "terminos" | "privacidad";

export interface LegalSection {
  heading: string;
  body: string;
}

export interface LegalDoc {
  id: LegalDocId;
  label: string;
  title: string;
  updated: string;
  sections: LegalSection[];
}

export const legalDocs: LegalDoc[] = [
  {
    id: "terminos",
    label: "Términos y condiciones",
    title: "Términos y condiciones",
    updated: "Octubre 2026",
    sections: [
      {
        heading: "Aceptación",
        body: "Al adquirir o utilizar Mindset Anti-Fragilidad y sus materiales complementarios, aceptás estos términos en su totalidad. Si no estás de acuerdo con ellos, te pedimos que no realices la compra.",
      },
      {
        heading: "Producto digital",
        body: "Mindset Anti-Fragilidad es un producto 100% digital compuesto por un ebook principal y bonus descargables. No se realizan envíos físicos. El acceso se otorga una vez confirmado el pago a través de la plataforma de cobro correspondiente.",
      },
      {
        heading: "Uso personal",
        body: "La compra otorga una licencia personal, intransferible y no exclusiva. Queda prohibido revender, compartir, copiar, distribuir o publicar total o parcialmente el contenido sin autorización expresa.",
      },
      {
        heading: "Propiedad intelectual",
        body: "Todos los textos, audios, diseños y materiales incluidos están protegidos por derechos de autor. Su uso no autorizado puede dar lugar a acciones legales.",
      },
      {
        heading: "Alcance del contenido",
        body: "El material tiene fines educativos y de desarrollo personal. No constituye asesoramiento financiero, legal, médico ni psicológico, y no reemplaza la consulta con profesionales. Los resultados dependen de la aplicación y circunstancias de cada persona; no se garantizan resultados económicos específicos.",
      },
      {
        heading: "Precios",
        body: "Los precios están expresados en pesos argentinos (ARS) y pueden modificarse sin previo aviso. El precio aplicable es el vigente al momento de la compra.",
      },
      {
        heading: "Modificaciones",
        body: "Nos reservamos el derecho de actualizar estos términos en cualquier momento. La versión vigente será siempre la publicada en este sitio.",
      },
    ],
  },
  {
    id: "privacidad",
    label: "Política de privacidad",
    title: "Política de privacidad",
    updated: "Octubre 2026",
    sections: [
      {
        heading: "Datos que recopilamos",
        body: "Solo recopilamos los datos necesarios para procesar tu compra y entregarte el producto, como tu nombre y correo electrónico. Los datos de pago son gestionados directamente por la plataforma de cobro y no son almacenados por nosotros.",
      },
      {
        heading: "Uso de la información",
        body: "Utilizamos tus datos para enviarte el acceso al producto, comunicarte novedades relacionadas con tu compra y mejorar la experiencia del sitio. Nunca vendemos ni alquilamos tu información a terceros.",
      },
      {
        heading: "Cookies",
        body: "Este sitio puede utilizar cookies y herramientas de medición para analizar el uso de la página y optimizar su funcionamiento. Podés desactivarlas desde la configuración de tu navegador.",
      },
      {
        heading: "Seguridad",
        body: "Aplicamos medidas razonables para proteger tus datos frente a accesos no autorizados, pérdida o alteración.",
      },
      {
        heading: "Tus derechos",
        body: "De acuerdo con la Ley 25.326 de Protección de Datos Personales, podés solicitar el acceso, rectificación o eliminación de tus datos en cualquier momento.",
      },
      {
        heading: "Cambios en esta política",
        body: "Esta política puede actualizarse periódicamente. La versión vigente será siempre la publicada en este sitio.",
      },
    ],
  },
];
